export default __webpack_public_path__ + "static/media/arupNewLogo.b63b3eee.svg";